import { render, staticRenderFns } from "./ShareCommunitiesSelect.vue?vue&type=template&id=5bf31126"
import script from "./ShareCommunitiesSelect.vue?vue&type=script&lang=js"
export * from "./ShareCommunitiesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports